// SLA aging helpers for the two-step approval tracker.
// Thresholds: Fresh < 24h · Warning 24-72h · Overdue > 72h.
export const AGING_THRESHOLDS = {
  warningH: 24,
  overdueH: 72,
};

// Returns { hours, tone: "fresh"|"warn"|"overdue"|"none", label: "3h 12m" }
export function computeAging(since) {
  if (!since) return { hours: 0, tone: "none", label: "—" };
  const then = new Date(since).getTime();
  const now = Date.now();
  const ms = Math.max(0, now - then);
  const hours = ms / 3_600_000;
  const label = fmtElapsed(ms);
  let tone = "fresh";
  if (hours >= AGING_THRESHOLDS.overdueH) tone = "overdue";
  else if (hours >= AGING_THRESHOLDS.warningH) tone = "warn";
  return { hours, tone, label };
}

// Compact human-readable elapsed string ("3m", "2h 14m", "4d 6h")
function fmtElapsed(ms) {
  const m = Math.floor(ms / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (h < 24) return rem ? `${h}h ${rem}m` : `${h}h`;
  const d = Math.floor(h / 24);
  const hr = h % 24;
  return hr ? `${d}d ${hr}h` : `${d}d`;
}

// Pick the right "since" timestamp for a REQ based on its status.
// pending → created_at (grey rot)
// verified → verified_at (yellow rot)
// everything else → null (no timer)
export function reqAgingSince(req) {
  if (!req) return null;
  if (req.status === "pending") return req.created_at || null;
  if (req.status === "verified") return req.verified_at || req.created_at || null;
  return null;
}

export function agingClasses(tone) {
  switch (tone) {
    case "overdue":
      return "border-red-600 bg-red-600 text-white";
    case "warn":
      return "border-amber-500 bg-amber-100 text-amber-900";
    case "fresh":
      return "border-neutral-300 bg-neutral-100 text-neutral-700";
    default:
      return "border-neutral-200 bg-white text-neutral-400";
  }
}
